import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import CourseCard from "@/components/CourseCard";

const CATEGORIES = ["Tümü", "Ön Muhasebe", "Genel Muhasebe", "Beyanname", "İleri Seviye"];

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const active = searchParams.get("kategori") || "Tümü";
  const query = searchParams.get("q") || "";

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    let list = courses;
    if (active !== "Tümü") list = list.filter((c) => c.category === active);
    if (query) list = list.filter((c) =>
      c.title.toLowerCase().includes(query.toLowerCase()) ||
      c.short_description.toLowerCase().includes(query.toLowerCase())
    );
    return list;
  }, [courses, active, query]);

  const setCat = (cat) => {
    const next = new URLSearchParams(searchParams);
    if (cat === "Tümü") next.delete("kategori"); else next.set("kategori", cat);
    setSearchParams(next);
  };
  const setQ = (v) => {
    const next = new URLSearchParams(searchParams);
    if (!v) next.delete("q"); else next.set("q", v);
    setSearchParams(next);
  };

  return (
    <div className="container-x py-16 md:py-24">
      <div className="mb-14 max-w-3xl">
        <span className="section-eyebrow">Eğitim Kataloğu</span>
        <h1 className="font-display text-5xl md:text-6xl mt-4 leading-tight">
          Tüm <span className="italic gold-gradient-text">programlar</span>.
        </h1>
        <p className="mt-5 text-white/70 max-w-xl">
          İhtiyacınıza en uygun programı seçin. Her eğitim için WhatsApp üzerinden
          ücretsiz tanışma dersi talep edip karar verebilirsiniz.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:items-center md:justify-between mb-10">
        <div className="flex flex-wrap items-center gap-2">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              data-testid={`filter-${cat}`}
              onClick={() => setCat(cat)}
              className={`text-xs uppercase tracking-[0.2em] px-4 py-2.5 border transition-colors ${
                (active === cat)
                  ? "border-gold text-gold bg-gold/5"
                  : "border-white/10 text-white/60 hover:text-gold hover:border-gold-30"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
        <div className="relative md:w-72">
          <input
            data-testid="course-search"
            type="text"
            placeholder="Ara..."
            value={query}
            onChange={(e) => setQ(e.target.value)}
            className="w-full bg-surface border border-white/10 focus:border-gold-30 outline-none px-4 py-2.5 text-sm placeholder:text-white/40"
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="py-24 text-center text-white/50">Bu kriterlere uygun eğitim bulunamadı.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filtered.map((c, i) => (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
            >
              <CourseCard course={c} />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
